import React from 'react';
import PropTypes from 'prop-types';
import Toggler from '@fiverr/ui_toggle';
import getRenderable from './lib/getRenderable';
import Tip from './Tip';
import './index.scss';

class Popover extends Toggler {

    constructor(props) {
        super(props);

        this.togglerWillClose = this.togglerWillClose.bind(this);
    }

    get popoverProps() {
        const {
            open, close, toggle, preventCloseAction
        } = this;

        const {
            isOpen
        } = this.state;

        const {
            trigger,
            children,
            ...props
        } = this.props;

        return Object.assign({}, {
            open, close, toggle, preventCloseAction, isOpen
        }, props);
    }

    togglerWillClose(done) {
        setTimeout(done);
    }

    render() {
        const {
            name,
            target,
            children,
            direction,
            placement
        } = this.props;

        const className = `toggler-popover popover-${name}`,
            popoverClass = `${direction} place-${placement}`;

        return (
            <div className={className}>
                <span className="target-wrap" ref={(ref) => this.target = ref}>
                    {getRenderable(target, this.popoverProps)}
                </span>
                {this.state.isOpen &&
                    <aside className={popoverClass}>
                        <Tip target={this.target} placement={placement}/>
                        {getRenderable(children, this.popoverProps)}
                    </aside>
                }
            </div>
        );
    }
}

Popover.propTypes = {
    name: PropTypes.string.isRequired,
    target: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.func
    ]),
    direction: PropTypes.string.isRequired,
    placement: PropTypes.string
};

export default Popover;
